import { combineReducers } from 'redux';

import genericErrorReducer from 'modules/global/reducers/generic.error';
import genericLoadingReducer from 'modules/global/reducers/generic.loading';
import genericPageReducer from 'modules/global/reducers/generic.page';
import * as types from 'modules/statistics/actionTypes';
import type { AuditInFilesTableRow, FetchAuditInFilesTableSuccessAction } from 'modules/statistics/types/auditInFiles';

import { createReducer } from 'utils/ReduxUtils';

import sort from './sort';

export default combineReducers({
  data: createReducer([], {
    [types.FETCH_AUDIT_IN_FILES_TABLE_SUCCESS]: (_: AuditInFilesTableRow[], { payload }: FetchAuditInFilesTableSuccessAction) => payload.content,
  }),
  page: genericPageReducer(types.FETCH_AUDIT_IN_FILES_TABLE_REQUEST),
  sort,
  apiError: genericErrorReducer(types.FETCH_AUDIT_IN_FILES_TABLE_REQUEST),
  isFetching: genericLoadingReducer(types.FETCH_AUDIT_IN_FILES_TABLE_REQUEST),
});
